import React, { FC, useState } from 'react';
import { ButtonComponent } from '../ButtonComponent';
import { SectionWrapper } from '../SectionWrapper';
import { useTranslation } from 'react-i18next';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { deleteUser } from '../../store/identyti/actions/users';
import { useNavigate } from 'react-router-dom';
import { useIdentity } from '../../store/identyti/identity-context';

export const UserDetailsAccount: FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { identityState: { usersList }} = useIdentity();
	const user = usersList[0];

	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	const onCloseModal = (): void => setModalState(prevState => ({ ...prevState, isOpen: false }));

	const closeDeleteModal = (): void => setIsDeleteModalOpen(false);

	const handleSuccess = (): void => {
		closeDeleteModal();
		setModalState({
      isOpen: true,
      modalTitle: 'Delete user',
      content: (
        <div className="fs-6">
          User was successfully deleted.
        </div>
      ),
      confirmButtonText: t('AGENCY.SUCCESS_BTN_NAME'),
      minHeight: 100,
      onConfirm: (): void => {
	      onCloseModal();
	      navigate('/users');
      },
      onClose: onCloseModal
    });
	};

	const handleError = (): void => {
		closeDeleteModal();
		setModalState({
      isOpen: true,
      modalTitle: 'Delete user',
      content: (
        <div className="fs-6">
          Failed deleting user.
        </div>
      ),
      confirmButtonText: t('AGENCY.FAIL_BTN_NAME'),
      minHeight: 100,
      onConfirm: onCloseModal,
      onClose: onCloseModal
    });
	};

	return (
		<>
			<SectionWrapper
				title={t('USER.ACCOUNT')}
				sectionAdditionalClass="account-border"
				isCardBody
			>
				<div className="text-muted fs-7 mb-3">
					Delete this user, once you delete a user, there is no going back. Please be certain.
				</div>
				<ButtonComponent
					buttonName="Delete"
					additionalClass="btn-sm"
					onButtonClick={(): void => setIsDeleteModalOpen(true)}
				/>
			</SectionWrapper>

			<ModalWindow
				{...modalState}
				onClose={onCloseModal}
			/>
			<ModalWindow
				isOpen={isDeleteModalOpen}
				onClose={closeDeleteModal}
				onCancel={closeDeleteModal}
				onConfirm={async (): Promise<void> => await deleteUser(user?.userName, handleSuccess, handleError)}
				backdrop="static"
				minHeight={100}
				modalTitle='Delete user'
				modalText='Attention! Are you sure, that you want to delete user? This action cannot be undone.'

			/>
		</>
	);
};

